/** How the Command Center draws one PostHog dashboard tile (productPulse.getDetail). */
export enum EPosthogTileKind {
  TRENDS = "trends",
  FUNNEL = "funnel",
  /** Retention, stickiness, HogQL, breakdown funnels, or nothing computed yet: title + link out only */
  LINK = "link",
}
